import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material';
import {PulseComponent} from './pulse.component';
import {pulseRouting} from './pulse.route';
import { DoctorComponent } from './doctor/doctor.component';
import { PulsemainComponent } from './pulsemain/pulsemain.component';
import { NgxLoadingModule, } from 'ngx-loading';

import { DoctordetailComponent } from './doctordetail/doctordetail.component';
import { BookingappointmentComponent } from './bookingappointment/bookingappointment.component';
import { MatNativeDateModule } from '@angular/material';
import { MatDialogModule, MatFormFieldModule } from '@angular/material';
import { DocschatComponent } from './docschat/docschat.component';

import { ProceedtochatComponent } from './proceedtochat/proceedtochat.component';

// import { NgxStepperModule } from '../../ngx-stepper';
import {
    MatRippleModule,
    MatButtonModule,
    MatIconModule,
    MatStepperModule,
    MatCardModule,
    MatSelectModule,
    MatDatepickerModule,
    MatRadioModule,
  } from '@angular/material';
import { AddnewpetComponent } from './addnewpet/addnewpet.component';
import { SharedModule } from '../common/shared.module';
import { PulsemenuComponent } from './pulsemenu/pulsemenu.component';
import { NgxPaginationModule } from 'ngx-pagination';
import {GoogleMapsAPIWrapper, MapsAPILoader} from '@agm/core';

import { AgmCoreModule } from '@agm/core';
import { AgmDirectionModule } from 'agm-direction';
import { MapdirectionComponent } from './mapdirection/mapdirection.component';
import { PleasewaitComponent } from '../pulse/pleasewait/pleasewait.component';
import { ShowalertComponent } from '../pulse/showalert/showalert.component';
import { UsersetreminderComponent } from './usersetreminder/usersetreminder.component';
import { ShowservicesComponent } from './showservices/showservices.component';
import { FilterModule } from '../filter/filter.module';
@NgModule({
    imports: [
      CommonModule,
      FlexLayoutModule,
      FormsModule,
      ReactiveFormsModule,
      NgbModule,
      pulseRouting,
      NgxLoadingModule,
      RouterModule,
      MatNativeDateModule,
      MatDialogModule,
      // NgxStepperModule,
      MatStepperModule,
      MatRippleModule,
      MatButtonModule,
      MatIconModule,
      MatCardModule,
      MatSelectModule,
      MatInputModule,
      MatDialogModule,
      MatFormFieldModule,
   MatDatepickerModule,
   MatRadioModule,
      NgxPaginationModule,
      SharedModule,
      AgmCoreModule.forRoot({
        apiKey: 'AIzaSyCVSpuWBEclSSgdccExuKLlKUORxWSqUFU',
        libraries: ['places']
      }),
      AgmDirectionModule,
      FilterModule,
],
    declarations: [
        PulseComponent,
        DoctorComponent,
        PulsemainComponent,
      //  SpecialPipe,
        DoctordetailComponent,
        BookingappointmentComponent,
        DocschatComponent,
       // OnlinedocPipe,
        ProceedtochatComponent,
        PleasewaitComponent,
        ShowalertComponent,
       // SearchPipe,
        AddnewpetComponent,
        PulsemenuComponent,
      //  GeolocationdistancePipe,
        MapdirectionComponent,
        UsersetreminderComponent,
        ShowservicesComponent,
    ],

       entryComponents: [
        AddnewpetComponent,
        ProceedtochatComponent,
        PleasewaitComponent,
        ShowalertComponent,
        MapdirectionComponent,
        ShowservicesComponent,
     ],
     providers: [ GoogleMapsAPIWrapper],
    })
    export class PulseModule { }
